import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { CustomerAddress, CustomerContactNumber, CustomerDetailInfoViewModel } from "../../../parties/model/customer.model";
import { takeUntil } from "rxjs/operators";
import { CustomerAddressOrderComponent } from "../customeraddressorder/customeraddressorder.component";
import { CustomerNumberOrderComponent } from "../customernumberorder/customernumberorder.component";
import { SimpleModalService } from "projects/sepidz-web-framework/src/lib/services/sepidzmodal/simple-modal.service";
import { CustomerOrderService } from "../customerorder.service";

@Component({
  selector: "order-customerdetails",
  templateUrl: "./customerdetailsorder.component.html",
  styleUrls: ["./customerdetailsorder.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerDetailsOrderComponent extends BaseListComponent {
  @Output() onStateChange: EventEmitter<any> = new EventEmitter<any>();
  @Input() customerOrder: CustomerOrderService;
  constructor(public cd: ChangeDetectorRef, public dialog: SimpleModalService) {
    super();
  }

  ngOnInit() {
    this.FillData();
  }

  FillData() {
    this.customerOrder.areaName = this.areaName;
    this.customerOrder.cd = this.cd;
  }

  //----------------------------------------------Address----------------------------------------------
  //نمایش وعدم نمایش زمان تارسیدن وپرکردن فیلد آدرس انتخاب شده
  ShowMinutesToDelivery(event, address: CustomerAddress) {
    if (event.target.checked) {
      this.customerOrder.currentCustomer.SelectedAddressId = address.Id;
    } else {
      this.customerOrder.currentCustomer.MinutesToDelivery = 0;
    }
  }

  //نمایش پاپ آپ ایجاد آدرس جدید
  ShowAddressDialog(data: CustomerDetailInfoViewModel) {
    this.dialog
      .open(
        CustomerAddressOrderComponent,
        {
          currentrow: data,
          errorMessage: "NotFound!!!",
        },
        {
          closeOnClickOutside: false,
        }
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((model: any) => {
        this.customerOrder.GetCustomerDetails(model.Id);
      });
  }
  //نمایش پاپ آپ ویرایش آدرس جدید
  ShowAddressEditDialog(data: CustomerDetailInfoViewModel) {
    var address = data.Addresses.find((x) => x.Id == data.SelectedAddressId);
    this.dialog
      .open(
        CustomerAddressOrderComponent,
        {
          currentrow: data,
          _address: address.Address,
          _zoneId: address.ZoneId,
          _isDefault: address.IsDefault,
          _AddressId: address.Id,
          errorMessage: "NotFound!!!",
        },
        {
          closeOnClickOutside: false,
        }
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((model: any) => {
        if (model && model.Addresses && model.Addresses.length > 0) {
          this.customerOrder.isEditing = true;
          this.customerOrder.GetCustomerDetails(data.Id);
        }
      });
  }

  //-----------------------------------------------Phone-----------------------------------------------
  //پر کردن فیلد تلفن انتخاب شده
  SetSelectedPhoneId(phone: CustomerContactNumber) {
    if (phone) {
      this.customerOrder.currentCustomer.SelectedPhoneId = phone.Id;
    }
  }
  //نمایش پاپ آپ ایجاد شماره تلفن جدید
  ShowPhoneDialog(data: CustomerDetailInfoViewModel) {
    this.dialog
      .open(
        CustomerNumberOrderComponent,
        {
          currentrow: data,
          errorMessage: "NotFound!!!",
        },
        {
          closeOnClickOutside: false,
        }
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((model: any) => {
        this.customerOrder.GetCustomerDetails(data.Id);
      }),
      500;
  }
  //نمایش پاپ آپ ویرایش شماره تلفن جدید
  ShowEditPhoneDialog(data: CustomerDetailInfoViewModel) {
    var numbers = data.Numbers.find((x) => x.Id == data.SelectedPhoneId);
    this.dialog
      .open(
        CustomerNumberOrderComponent,
        {
          currentrow: data,
          errorMessage: "NotFound!!!",
          _numberTypeId: numbers.NumberTypeId,
          _number: numbers.Number,
          _isDefault: numbers.IsDefault,
          _PhoneId: numbers.Id,
        },
        {
          closeOnClickOutside: false,
        }
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((model: any) => {
        if (model && model.Numbers && model.Numbers.length > 0) {
          this.customerOrder.isEditing = true;
          this.customerOrder.GetCustomerDetails(data.Id);
        }
      });
  }
}
